import {
  Button,
  Card,
  Col,
  Descriptions,
  Modal,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
  Watermark,
} from "antd";
import React, { useImperativeHandle, useEffect, useState, useRef } from "react";
import { logoBill, logoFullWhite, logoIconWhite } from "assets/images/logo/";
import { CallSVG, CaptivePortalSVG, MailWhiteSVG } from "assets";
import dayjs from "dayjs";
import {
  doiTuongOptions,
  gioiTinhOptions,
} from "assets/constants/select-catagory-options";
import {
  birthday2Age,
  convertIosStringToDate,
  convertIosStringToDateDayjs,
  convertToWords,
  formatDateToString,
  formatToCurrencyType,
  formatToCurrencyTypeToFixed,
  normalizePhoneNumber,
} from "helper/common";
import "./PaymentBill.scss";
import { medicalExaminationService } from "api";
import ReactToPrint from "react-to-print";
import { capitalize, getTodayString, serviceColumns } from "./config";
import { parseDatetime } from "helper/format-date";
import { HeaderPrintForm } from "components/common";
import moment from "moment";
import { FORMAT_TIME } from "types/enums";
import { listPhuongThucTT } from "data/list";
import { ReactComponent as PhoneSVG } from "assets/icons/phone-svg.svg";
import { ReactComponent as MailSVG } from "assets/icons/mail-svg.svg";
import { ReactComponent as InternetSVG } from "assets/icons/internet-svg.svg";
import { ReactComponent as LocationSVG } from "assets/icons/location-svg.svg";
const HINHTHUCTHANHTOAN = [
  { value: 0, label: "Tiền mặt" },
  { value: 1, label: "Chuyển khoản" },
  { value: 2, label: "Quẹt thẻ" },
];
const PaymentBill = React.forwardRef((props, ref) => {
  const printRef = useRef<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [thongTinBN, setThongTinBN] = useState<any>(null);
  const [cards, setCards] = useState<any>([]);
  const [thongTinTT, setThongTinTT] = useState<any>(null);
  console.log("tth", thongTinTT);

  useImperativeHandle(ref, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    setThongTinBN: setThongTinBN,
    setCards: setCards,
    setThongTinTT: setThongTinTT,
  }));
  useEffect(() => {});
  useEffect(() => {}, [isModalOpen]);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const getThanNhan = (hoTen, quanHe) => {
    if (hoTen) {
      return quanHe ? hoTen + `(${quanHe})` : hoTen;
    }
    return "";
  };

  const onPrint = async () => {
    window.print();
  };

  useEffect(() => {
    console.log(thongTinTT);
  }, [thongTinBN, thongTinTT]);
  useEffect(() => {}, [cards]);
  return (
    <Row className="payment-bill">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        closable={false}
        footer={null}
        width={window.innerWidth < 720 ? "90%" : "80%"}
        destroyOnClose={true}
      >
        <div>
          <div ref={printRef} style={{ padding: "30px 0" }}>
            <div className="print-content" style={{marginLeft:"15px",marginRight:"15px"}}>
              <div className="header-print-form">
                <Row
                  align={"middle"}
                  justify={"space-between"}
                  style={{ padding: "0 10px 0 8px" }}
                >
                  <Col span={22} 
                   style={{ marginLeft: "10px" }}
                  >
                    <Row>
                      <Typography.Text strong style={{ fontSize: "16px" }}>
                        Bệnh viện chuyên khoa mắt Alina
                      </Typography.Text>
                    </Row>
                    <Row gutter={8} justify={"space-between"}>
                      <Col span={7}>
                        <Row
                          style={{ alignItems: "flex-start" }}
                          align={"middle"}
                        >
                          <Col flex={"auto"}>
                            <LocationSVG />
                          </Col>
                          <Col span={22}>
                            <Typography.Text style={{ fontSize: "14px" }}>
                              Địa chỉ: Biệt thự Mimosa 10-11-12, KĐT Ecopark,
                              Văn Giang, Hưng Yên
                            </Typography.Text>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={4}>
                        <Row style={{ gap: "8px" }} align={"middle"}>
                          <Col>
                            <PhoneSVG />
                          </Col>
                          <Col>
                            <Typography.Text style={{ fontSize: "14px" }}>
                              0866.224.883
                            </Typography.Text>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={6}>
                        <Row style={{ gap: "8px" }} align={"middle"}>
                          <Col>
                            <MailSVG />
                          </Col>
                          <Col>
                            <Typography.Text style={{ fontSize: "14px" }}>
                              cskh@alinavision.com
                            </Typography.Text>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={5}>
                        <Row style={{ gap: "8px" }} align={"middle"}>
                          <Col>
                            <InternetSVG />
                          </Col>
                          <Col>
                            <Typography.Text style={{ fontSize: "14px" }}>
                              http://alinavn.com
                            </Typography.Text>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col flex={"auto"}>
                    <Row justify={"end"}>
                      <img
                        src={logoBill}
                        style={{
                          height: "32px",
                          marginRight:"10px"
                        }}
                      />
                    </Row>
                  </Col>
                </Row>
                <div style={{ border: "1px solid #d9d9d9" }}></div>
              </div>
              <Row
                style={{
                  paddingLeft: "16px",
                  paddingTop: "10px",
                  paddingRight: "16px",
                }}
              >
                <Row justify={"center"}>
                  <Typography.Title
                    style={{
                      fontSize: "20px",
                      fontWeight: "700",
                      margin: "0 0 4px 0",
                    }}
                  >
                    PHIẾU THANH TOÁN
                  </Typography.Title>
                </Row>
                {/* <Row>
                  <Col span={10}>
                    <Row>
                      <Descriptions
                        column={{
                          xs: 1,
                          sm: 1,
                          md: 1,
                          xl: 1,
                          lg: 1,
                          xxl: 1,
                        }}
                        size="small"
                      >
                        <Descriptions.Item
                          label={<Typography.Text>Họ và tên</Typography.Text>}
                          labelStyle={{width: "94px"}}
                          contentStyle={{
                            fontWeight: "600",
                          }}
                        >
                          <Typography.Text>{thongTinBN?.hoTen}</Typography.Text>
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={<Typography.Text>Ngày sinh</Typography.Text>}
                          labelStyle={{width: "94px"}}
                          contentStyle={{
                            fontWeight: "600",
                          }}
                        >
                          <Typography.Text>
                            {thongTinBN?.ngaySinh
                              ? dayjs(thongTinBN?.ngaySinh).format("DD/MM/YYYY")
                              : ""}
                          </Typography.Text>
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={<Typography.Text>Tuổi</Typography.Text>}
                          labelStyle={{width: "94px"}}
                          contentStyle={{
                            fontWeight: "600",
                          }}
                        >
                          <Typography.Text>
                            {thongTinBN?.ngaySinh
                              ? birthday2Age(thongTinBN?.ngaySinh)
                              : ""}
                          </Typography.Text>
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={<Typography.Text>Giới tinh</Typography.Text>}
                          labelStyle={{width: "94px"}}
                          contentStyle={{
                            fontWeight: "600",
                          }}
                        >
                          <Typography.Text>
                            {gioiTinhOptions.find(
                              it => it.value === thongTinBN?.gioiTinh
                            )?.label || ""}
                          </Typography.Text>
                        </Descriptions.Item>
                      </Descriptions>
                    </Row>
                  </Col>
                  <Col span={10}>
                    <Descriptions
                      column={{
                        xs: 1,
                        sm: 1,
                        md: 1,
                        xl: 1,
                        lg: 1,
                        xxl: 1,
                      }}
                    >
                      <Descriptions.Item
                        label={<Typography.Text>Điện thoại</Typography.Text>}
                        labelStyle={{width: "94px"}}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        <Typography.Text>
                          {thongTinBN?.dienThoai ?? ""}
                        </Typography.Text>
                      </Descriptions.Item>
                      <Descriptions.Item
                        label={<Typography.Text>Địa chỉ</Typography.Text>}
                        labelStyle={{width: "94px"}}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        <Typography.Text>
                          {thongTinBN?.diaChiTongHop ?? ""}
                        </Typography.Text>
                      </Descriptions.Item>
                      <Descriptions.Item
                        label={<Typography.Text>Số thẻ BH</Typography.Text>}
                        labelStyle={{width: "94px"}}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        <Typography.Text>
                          {thongTinBN?.maTheBhyt ?? ""}
                        </Typography.Text>
                      </Descriptions.Item>
                      <Descriptions.Item
                        label={<Typography.Text>Nhân thân</Typography.Text>}
                        labelStyle={{width: "94px"}}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        <Typography.Text>
                          {`${thongTinBN?.hoTenThanNhan ?? ""} ${
                            thongTinBN?.quanHeThanNhan
                              ? "(" + thongTinBN?.quanHeThanNhan + ")"
                              : ""
                          }`}
                        </Typography.Text>
                      </Descriptions.Item>
                    </Descriptions>
                  </Col>
                  <Col span={4}>
                    <Row justify={"end"}>
                      <QRCode
                        value={`${thongTinBN?.id} - ${thongTinBN?.maBenhNhan}`}
                        size={96}
                      />
                    </Row>
                  </Col>
                </Row> */}
                <Row justify={"space-between"}>
                  <Col>
                    <Typography.Text style={{ fontWeight: "800" }}>
                      {thongTinBN?.hoTen?.toUpperCase()}
                    </Typography.Text>
                    {thongTinBN?.gioiTinh
                      ? ` - ${
                          gioiTinhOptions.find(
                            (it) => it.value === thongTinBN?.gioiTinh
                          )?.label
                        }`
                      : ""}{" "}
                    -{" "}
                    {thongTinBN?.ngaySinh
                      ? birthday2Age(thongTinBN?.ngaySinh)
                      : ""}{" "}
                    tuổi -
                    {thongTinBN?.ngaySinh
                      ? `(SN: ${formatDateToString(
                          convertIosStringToDateDayjs(thongTinBN?.ngaySinh)
                        )})`
                      : "(SN: )"}
                    {/* {thongTinBN?.soDienThoai ? ` - ${thongTinBN.soDienThoai}` : ""} */}
                  </Col>
                  <Col span={10}>
                    <Row justify={"space-between"}>
                      {/* <Space size={30}> */}
                      <Typography.Text>
                        Thời gian khám: &nbsp;
                        <Typography.Text>
                          {thongTinBN?.ngayNhapVien
                            ? dayjs(thongTinBN?.ngayNhapVien).format(
                                FORMAT_TIME.dateTime
                              )
                            : ""}
                        </Typography.Text>
                      </Typography.Text>
                      <Typography.Text>
                        Mã bệnh nhân: &nbsp;
                        <Typography.Text strong>
                          {thongTinBN?.maBenhNhan}
                        </Typography.Text>
                      </Typography.Text>
                      {/* </Space> */}
                    </Row>
                  </Col>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Typography.Text>
                      Địa chỉ: &nbsp;
                      <Typography.Text>
                        {thongTinBN?.diaChiTongHop}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col
                    style={{
                      marginRight: thongTinBN?.dienThoai ? "0px" : "90px",
                    }}
                  >
                    <Typography.Text>
                      SĐT: &nbsp;
                      <Typography.Text>
                        {thongTinBN?.dienThoai
                          ? ` ${thongTinBN.dienThoai}`
                          : ""}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                </Row>
                <div className="my-table-custom">
                  <table>
                    <tr>
                      <th style={{ width: "4%" }}>
                        <Typography.Text strong>STT</Typography.Text>
                      </th>
                      <th style={{ width: "12%" }}>
                        <Typography.Text strong>Mã loại thẻ</Typography.Text>
                      </th>
                      <th style={{ width: "26%" }}>
                        <Typography.Text strong>Tên loại thẻ</Typography.Text>
                      </th>
                      <th style={{ width: "8%" }}>
                        <Typography.Text strong>Số lượng</Typography.Text>
                      </th>
                      <th style={{ width: "26%" }}>
                        <Typography.Text strong>Tên dịch vụ</Typography.Text>
                      </th>
                      <th style={{ width: "8%" }}>
                        <Typography.Text strong>Số lượng</Typography.Text>
                      </th>
                      <th style={{ width: "8%" }}>
                        <Typography.Text strong>Thời hạn</Typography.Text>
                      </th>
                      <th style={{ width: "8%" }}>
                        <Typography.Text strong>Giá thẻ</Typography.Text>
                      </th>
                    </tr>
                    {cards.map((it, idx) => {
                      return (
                        <>
                          <tr>
                            <td
                              className="ta-c"
                              rowSpan={it?.dichVuTrongThes?.length ?? 1}
                            >
                              <Typography.Text>{idx + 1}</Typography.Text>
                            </td>
                            <td
                              className="ta-c"
                              rowSpan={it?.dichVuTrongThes?.length ?? 1}
                            >
                              <Typography.Text>{it?.ma ?? ""}</Typography.Text>
                            </td>
                            <td
                              className="ta-c"
                              rowSpan={it?.dichVuTrongThes?.length ?? 1}
                            >
                              <Typography.Text>
                                {it?.tenLoaiThe ?? ""}
                              </Typography.Text>
                            </td>
                            <td
                              style={{ textAlign: "center" }}
                              className="ta-r"
                              rowSpan={it?.dichVuTrongThes?.length ?? 1}
                            >
                              <Typography.Text>
                                {it?.soLuong ?? ""}
                              </Typography.Text>
                            </td>
                            <td>
                              <Typography.Text>
                                {it?.dichVuTrongThes[0]?.tenDichVu ?? ""}
                              </Typography.Text>
                            </td>
                            <td
                              style={{ textAlign: "center" }}
                              className="ta-r"
                            >
                              <Typography.Text>
                                {it?.dichVuTrongThes[0]?.soLan === -1
                                  ? "KGH"
                                  : it?.dichVuTrongThes[0]?.soLan ?? ""}
                              </Typography.Text>
                            </td>
                            {/* <td>
                            {it?.dichVuTrongThes?.map(dt => {
                                return (
                                  <Typography.Text>
                                    {dt?.tenDichVu ?? ""}
                                  </Typography.Text>
                                );
                              })
                            }
                          </td> */}
                            {/* <td>
                            {it?.dichVuTrongThes?.map(dt => {
                                return (
                                  <Typography.Text>
                                    {dt?.soLan === -1
                                      ? "KGH"
                                      : dt?.soLan ?? ""}
                                  </Typography.Text>
                                );
                              })
                            }
                          </td> */}
                            <td
                              className="ta-c"
                              rowSpan={it?.dichVuTrongThes?.length ?? 1}
                            >
                              <Typography.Text>
                                {it?.thoiHan === 0
                                  ? "Vĩnh viễn"
                                  : `${
                                      it?.thoiHan ? it?.thoiHan + " tháng" : ""
                                    }`}
                              </Typography.Text>
                            </td>
                            <td
                              className="ta-r"
                              rowSpan={it?.dichVuTrongThes?.length ?? 1}
                            >
                              <Typography.Text>
                                {it?.giaBan
                                  ? formatToCurrencyType(it?.giaBan)
                                  : ""}
                              </Typography.Text>
                            </td>
                          </tr>

                          {it?.dichVuTrongThes?.slice(1)?.map((dt) => {
                            return (
                              <tr>
                                <td className="ta-l">
                                  <Typography.Text>
                                    {dt?.tenDichVu ?? ""}
                                  </Typography.Text>
                                </td>
                                <td
                                  style={{ textAlign: "center" }}
                                  className="ta-r"
                                >
                                  <Typography.Text>
                                    {dt?.soLan == -1 ? "KGH" : dt?.soLan ?? ""}
                                  </Typography.Text>
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      );
                    })}
                  </table>
                </div>
                <Row
                  style={{
                    marginTop: "16px",
                    justifyContent: "space-between",
                    alignItems: "start",
                    flexDirection: "row",
                  }}
                >
                  <Col style={{flex: 1}}>
                    <Row>
                      <Typography.Text>
                        Thành tiền: &nbsp;
                        <Typography.Text strong>
                          {thongTinTT?.thanhTien
                            ? formatToCurrencyType(thongTinTT?.thanhTien)
                            : ""}
                        </Typography.Text>
                      </Typography.Text>
                    </Row>
                    <Row>
                      <Typography.Text>
                        Bằng chữ: &nbsp;
                        <Typography.Text strong>
                          {thongTinTT?.thanhTien
                            ? capitalize(convertToWords(thongTinTT?.thanhTien))
                            : ""}
                        </Typography.Text>
                      </Typography.Text>
                    </Row>
                    <Row>
                      <Typography.Text>
                        Phương thức thanh toán: &nbsp;
                      </Typography.Text>
                      <Col>
                        {thongTinTT?.hoanThanhThanhToanBenhNhanDtos?.map(
                          (e) => (
                            <Row>
                              <Typography.Text>
                                {
                                  listPhuongThucTT?.find(
                                    (tt) => tt?.value == e?.idHinhThucThanhToan
                                  )?.label
                                }
                                :{" "}
                                {formatToCurrencyTypeToFixed(e?.soTienGiaoDich)}
                              </Typography.Text>
                            </Row>
                          )
                        )}
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "0px" }}>
                      <Typography.Text
                        type="secondary"
                        italic
                      >{`Lưu ý: "Quý khách có nhu cầu hoá đơn VAT vui lòng báo lễ tân / CSKH 0866.224.883 ngay trong ngày phát sinh dịch vụ. Bệnh viện không hỗ trợ xuất hoá đơn VAT nếu nhận thông tin sau thời điểm này. Xin cảm ơn"`}</Typography.Text>
                    </Row>
                  </Col>
                  <Col style={{flex: 1}}>
                    {/* <Row>
                  <Typography.Text>
                    Hình thức thanh toán: &nbsp;
                    <Typography.Text strong>
                      {HINHTHUCTHANHTOAN.find(
                        it => it.value === thongTinTT?.hinhThucThanhToan
                      )?.label || ""}
                    </Typography.Text>
                  </Typography.Text>
                </Row> */}

                    <Row style={{ marginTop: "0px" }}>
                      <Row justify={"end"}>
                        <Typography.Text className="date-sign">
                          {getTodayString()}
                        </Typography.Text>
                      </Row>
                      <Row justify={"end"}>
                        {/* <Col>
                    <Space direction='vertical' size={64}>
                      <Row>
                        <Row justify={'center'}><Typography.Text strong>Bệnh nhân/Thân nhân</Typography.Text></Row>
                        <Row justify={'center'}><Typography.Text type='secondary'>(Ký và ghi rõ họ tên)</Typography.Text></Row>
                      </Row>
                      <Row justify={'center'}>
                        <Typography.Text strong>{thongTinBN?.hoTen}</Typography.Text>
                      </Row>
                    </Space>
                  </Col> */}
                        <Col>
                          <Space direction="vertical" size={50}>
                            <Row>
                              <Row justify={"center"}>
                                <Typography.Text strong>
                                  Người bán
                                </Typography.Text>
                              </Row>
                              <Row justify={"center"}>
                                <Typography.Text type="secondary">
                                  (Ký và ghi rõ họ tên)
                                </Typography.Text>
                              </Row>
                            </Row>
                            <Row justify={"center"}>
                              <Typography.Text strong>
                                {localStorage.getItem("fullName")}
                              </Typography.Text>
                            </Row>
                          </Space>
                        </Col>
                      </Row>
                      <Row></Row>
                    </Row>
                  </Col>
                </Row>
              </Row>
            </div>
          </div>
        </div>
        <Row justify={"end"} style={{ marginTop: "8px", gap: "4px" }}>
          <Button type="primary" danger onClick={closeModal}>
            HỦY
          </Button>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  IN
                </Button>
              );
            }}
            content={() => printRef.current}
            onAfterPrint={closeModal}
          />
        </Row>
      </Modal>
    </Row>
  );
});
export default PaymentBill;
